<template>
  <k-dialog @close="cancel" :max-width="400" :title="action">
    <form class="k-form" @submit.prevent="save">
      <div style="width: 50vw">
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">Role Name</label>

          <div class="col-sm-9">
            <k-input
              type="text"
              :name="'userName'"
              v-model="roleInEdit.roleName"
              class="form-control"
              required
            ></k-input>
          </div>
        </div>

        <!-- <div
        class="form-group row"
        v-if="roleInEdit.identityPoolID"
        :style="{ marginBottom: '1rem' }"
      >
        <label class="col-sm-3 text-left col-form-label">
          Identity Pool :
        </label>
        <div class="col-sm-9">
          <p class="form-control">
            {{ roleInEdit.identityPoolID }}
          </p> -->
        <!-- <kendo-multiselect
            ref="multiselect"
            v-model="roleInEdit.identityPoolID"
            :data-text-field="'name'"
            :data-value-field="'id'"
            :value-primitive="false"
            :data-source="dataSourceArray"
            :max-selected-items="1"
            :placeholder="'Select Identity Pool...'"
            :filter="'contains'"
            class="form-control"
          >
          </kendo-multiselect> -->
        <!-- </div>
      </div> -->
      </div>
      <input type="submit" id="submit-form" class="d-none" />
    </form>

    <div class="d-flex ">
      <button class="k-button col-6" @click="cancel" >Cancel</button>
      <label class="k-button k-primary col-6 mb-0" for="submit-form" tabindex="0"
        >Save</label
      >
    </div>

  </k-dialog>
</template>
<script>
import { Dialog, DialogActionsBar } from "@progress/kendo-vue-dialogs";
import { NumericTextBox, Input } from "@progress/kendo-vue-inputs";
import { MultiSelect } from "@progress/kendo-dropdowns-vue-wrapper";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    "k-input": Input,
    numerictextbox: NumericTextBox,
    "k-dialog": Dialog,
    "dialog-actions-bar": DialogActionsBar,
    "kendo-multiselect": MultiSelect,
  },
  props: {
    dataItem: Object,
    dialogTitle: String,
  },
  data: function () {
    return {
      roleInEdit: {
        name: "",
        identityPoolID: "",
      },
      action: "",
      multiselectValue: [],
    };
  },
  validations: {
    roleInEdit: {},
  },
  created: function () {
    console.log(this.$props.dialogTitle);
    if (this.$props.dataItem) {
      this.roleInEdit = this.$props.dataItem;
      console.log(this.roleInEdit.roles);
    } else {
      this.roleInEdit = {
        roleName: "",
        identityPoolID: "",
      };
    }
  },

  mounted: function () {
    // console.log(this.$refs);
    // var t = this.$refs.multiselect.kendoWidget();
    // t.value(this.roleInEdit.roles);
    // console.log(this.roleInEdit.roles);
    // console.log(t.value());
    this.action = this.$props.dialogTitle;
  },

  computed: {},
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    save() {
      console.log("SAVED");
      if (this.action == "Edit role") {
        this.$props.isNewRole = false;
        this.$emit("editRole");
      } else {
        console.log(this.roleInEdit.roles);
        this.$emit("save");
      }
    },
  },
};
</script>
<style scoped>
</style>